// extracted by mini-css-extract-plugin
module.exports =  {"container":"container_ntGW_9GQ"};